var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 20.105a8.105 8.105 0 1 0 0-16.21 8.105 8.105 0 0 0 0 16.21ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-12.372a1.316 1.316 0 1 1 0-2.632 1.316 1.316 0 0 1 0 2.632Zm-.947 2.822c0-.541.424-.98.947-.98.523 0 .947.439.947.98v3.83c0 .54-.424.98-.947.98-.523 0-.947-.44-.947-.98v-3.83Z"
})));
export { SvgInfoOutline24 as ReactComponent };